import { Plus, X } from "lucide-react";
import ImageField from "./ImageField";

export default function GalleryField({ value = [], onChange, testid = "gallery" }) {
  const items = Array.isArray(value) ? value : [];
  const update = (i, v) => { const next = [...items]; next[i] = v; onChange(next); };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const add = () => onChange([...items, ""]);
  return (
    <div className="space-y-3" data-testid={testid}>
      {items.map((v, i) => (
        <div key={i} className="flex gap-2 items-start">
          <div className="flex-1"><ImageField value={v} onChange={(val) => update(i, val)} testid={`${testid}-${i}`} /></div>
          <button type="button" onClick={() => remove(i)} data-testid={`${testid}-remove-${i}`}
            className="p-2 text-ink/40 hover:text-red-600 transition-colors shrink-0"><X className="w-4 h-4" /></button>
        </div>
      ))}
      <button type="button" onClick={add} data-testid={`${testid}-add`}
        className="inline-flex items-center gap-2 px-4 py-2 border border-dashed border-ink/25 hover:border-gold hover:text-gold transition-colors text-sm">
        <Plus className="w-4 h-4" /> Añadir imagen
      </button>
    </div>
  );
}
